export enum ErrorType {
    USER_NOT_LOGGED = 'USER_NOT_LOGGED',
    NO_RESPONSE = 'NO_RESPONSE',
    SERVICE_ERROR = 'SERVICE_ERROR'
}

export class Errors extends Error {
    constructor(
        public type: ErrorType,
        message: string,
        public originalError?: any
    ) {
        super(message);
    }
}